import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { toast } from "react-toastify";
import { BasicTable } from "../../../../../../theme/Component/BasicTable";
import { _AssetItemHistory } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { _AssignedMaintenanceType, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { ModalConfirm } from "../../../../../../theme/Component/ModalConfirm";
import { Modal } from "../../../../../../theme/Component/Modal";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { SelectMaintenanceTypeItem } from "../../../../../../Factoty&Production/Maintenance/MaintenanceTypeItem/SelectMaintenanceTypeItem";

interface Props {
    idItem: number;
}

interface Form {
    State: number;
}


export const AssignedMaintenanceType = ({ idItem }: Props) => {
    const { instance, lista, bean, setBean, setLista } = useDataBean(_AssignedMaintenanceType)

    const [form, setForm] = useState<Partial<Form>>({
        State: 1
    })

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idItem])

    const getLista = () => {
        const props = {
            State: form.State,
            IDItem: idItem,
        }
        instance.getAssignedMaintenanceTypeCatalogPorPropiedades(props, null).then(
            (resp: any) => {
                setLista(resp);
            }
        ).catch(
            err => { toast.error(err) }
        )
    }

    const create = () => {
        setBean({
            IDItem: idItem,
            State: 1,
        });
        setModal({ ...modal, "view": true, name: "Agregar Tipo de mantenimiento" });
    }

    const deleteItem = () => {
        const x = { ...bean, State: 2 };
        editaItem(x);
        setModalC({ ...modalC, view: false });
    };

    const editaItem = (obj: any) => {
        instance.updateAssignedMaintenanceType(obj).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })
    }

    const head = [
        { title: 'ID', property: 'IDAssignedMaintenanceType', visible: true },
        { title: 'IDItem', property: 'IDItem', visible: true },
        { title: 'Tipo de Mantenimiento', property: 'IDMaintenanceTypeItem', visible: true },
        { title: 'Notas', property: 'Notes', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar`, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable listButtons={listaBotones()} iconButtons={iconButtonsItem} body={lista} head={head} rowSet={setBean} />


                <Modal modal={modal} updateModal={setModal} eventModal={() => { editaItem(bean) }}>
                    <div className="row">
                        <div className="col-md-12">
                            <label>Tipo de Mantenimiento</label>
                            <SelectMaintenanceTypeItem idSelector={bean.IDMaintenanceTypeItem} onChange={(e) => { setBean({ ...bean, IDMaintenanceTypeItem: e }) }} label="" />
                        </div>
                        <div className="col-md-12">
                            <label >Notas</label>
                            <textarea className="form-control" value={bean.Notes} onChange={(e) => { setBean({ ...bean, Notes: e.target.value }) }} />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item {bean.Name}</strong>
                </ModalConfirm>
            </div>
        </div>
    )
}